import createReducer from '../utils/createReducer';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import { STATIC_CONTENT } from '../constants/apiTypes';

const initialState = {};

const staticContentReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) => {
    if (action.api === STATIC_CONTENT) {
      return {
        [action.key]: {
          content: '',
          errors: {},
          isLoading: true
        }
      };
    }
    return undefined;
  },

  [API_CALL_SUCCESS]: (state, action) => {
    if (action.api === STATIC_CONTENT) {
      return {
        [action.key]: {
          content: action.data.content,
          errors: {},
          isLoading: false
        }
      };
    }
    return undefined;
  },

  [API_CALL_FAILURE]: (state, action) => {
    if (action.api === STATIC_CONTENT) {
      return {
        [action.key]: {
          content: '',
          errors: action.errors,
          isLoading: false
        }
      };
    }
    return undefined;
  }
});

export default staticContentReducer;
